import { useEffect, useRef, useMemo, useState } from "react";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import { useMap } from "react-leaflet/hooks";

import MarkerCluster from "./MarkerCluster";

import "./index.css";

const GeoJsonLayer = ({ features }) => {
  const ref = useRef(null);
  const map = useMap();

  useEffect(() => {
    map.fitBounds(ref.current.getBounds());
  }, []);

  return (
    <GeoJSON
      ref={ref}
      data={{ features }}
      style={{ color: "#4d4d4d", weight: 1 }}
    />
  );
};

const ClusterMap = (props) => {
  const [bounds, setBounds] = useState(null);
  const [zoom, setZoom] = useState(10);

  const data = useMemo(() => {
    return props.markers.map((item, index) => {
      return {
        type: "Feature",
        properties: {
          cluster: false,
          category: "facility",
          facilityId: item.id,
        },
        geometry: {
          type: "Point",
          coordinates: [
            parseFloat(item.geometry[1]),
            parseFloat(item.geometry[0]),
          ],
        },
      };
    });
  }, [JSON.stringify(props.markers)]);

  return (
    <MapContainer
      doubleClickZoom={true}
      zoomControl={true}
      dragging={true}
      scrollWheelZoom={true}
      zoom={zoom}
    >
      <TileLayer
        attribution={`&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>`}
        url="https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png"
      />
      <GeoJsonLayer {...props} />
      <MarkerCluster
        points={data}
        bounds={bounds}
        zoom={zoom}
        markers={props.markers}
        setBounds={setBounds}
        setZoom={setZoom}
      />
    </MapContainer>
  );
};
export default ClusterMap;
